export { default } from "ember-stereo/modifiers/stereo-volume";
